import { faPen } from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  FamilyParentProfile,
  JoonUIColor,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import ParentAvatar from "../../../components/parentAvatar/ParentAvatar"
import { useFamilyQuery, useUserQuery } from "../../../networking/queries"
import useEditProfileModalStore from "../hooks/useEditProfileModalStore"
import useFamilyUserSelectStore from "../hooks/useFamilyUserSelect"
import useSelectedFamilyMember from "../hooks/useSelectedFamilyMember"

const ParentProfileSection = () => {
  const { user } = useUserQuery()
  const { data: family } = useFamilyQuery()
  const { onOpen: openEditProfileModal } = useEditProfileModalStore()
  const { selectedUserId } = useFamilyUserSelectStore()
  const { selectedProfile } = useSelectedFamilyMember()
  const { t } = useTranslation()
  const isCurrentUser = selectedUserId === user?.id

  if (!user || !family) return <></>

  const parentProfile = selectedProfile as FamilyParentProfile | undefined

  const handleEdit = () => {
    if (parentProfile) openEditProfileModal(parentProfile)
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row items-center justify-between gap-2">
        <Typography variant="bodyBold">
          {isCurrentUser ? t("PPS_MY_PROFILE") : t("PPS_PROFILE")}
        </Typography>
        {isCurrentUser && (
          <button
            className="flex flex-row items-center gap-1"
            onClick={handleEdit}
          >
            <FontAwesomeIcon
              icon={faPen}
              color={JoonUIColor.icon.accent}
              fontSize={12}
            />
            <Typography variant="bodySmall" color={JoonUIColor.icon.accent}>
              {t("QUEST_HEADER_EDIT")}
            </Typography>
          </button>
        )}
      </div>
      <div className="flex flex-col overflow-hidden border rounded-md border-borderPrimary">
        <div className="flex flex-row items-center justify-between gap-2 p-3 bg-white border-b border-borderPrimary">
          <Typography variant="bodySmall">{t("PPS_AVATAR")}</Typography>
          <button onClick={handleEdit}>
            <ParentAvatar
              avatar={parentProfile?.user?.parent_doter.type ?? null}
              size={48}
              className="rounded-full"
            />
          </button>
        </div>
        <div className="flex flex-row items-center justify-between gap-2 p-3 bg-white border-b border-borderPrimary">
          <Typography variant="bodySmall">
            {t("PPS_IN_APP_NICKNAME")}
          </Typography>
          <Typography variant="bodySmall">
            {(selectedProfile as FamilyParentProfile)?.nickname}
          </Typography>
        </div>
        <div className="flex flex-row items-center justify-between gap-2 p-3 bg-white">
          <Typography variant="bodySmall">{t("PPS_FULL_NAME")}</Typography>
          <Typography variant="bodySmall">
            {parentProfile?.user.name} {parentProfile?.user.last_name}
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default ParentProfileSection
